



























import { defineComponent, PropType, computed } from '@vue/composition-api';
import { ActiveIndexType, ImageList, DEFAULT_IMAGE_INDEX } from './types';
import ImageItem from './components/music-carousel-image-item.vue';
import Draggable from 'vuedraggable';

const name = 'ttam-creative-music-carousel-material-display-compose';
export default defineComponent({
  name,
  components: {
    ImageItem,
    Draggable,
  },
  props: {
    imageList: {
      type: Array as PropType<ImageList>,
      default: () => [],
    },
    activeId: {
      type: String as PropType<ActiveIndexType>,
      default: () => DEFAULT_IMAGE_INDEX,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  setup(props, ctx) {
    const imageListLocal = computed({
      get() {
        return props.imageList;
      },
      set(value) {
        ctx.emit('order-change', value);
      },
    });

    const checkIsActive = index => props.activeId === index;

    const onImageItemClick = clickIndex => {
      if (clickIndex !== props.activeId) {
        ctx.emit('active-change', clickIndex);
      }
    };

    const onDelete = deleteId => ctx.emit('image-delete', deleteId);

    const onImageUpdate = data => ctx.emit('image-update', data);

    return {
      onDelete,
      checkIsActive,
      onImageUpdate,
      imageListLocal,
      onImageItemClick,
    };
  },
});
